angular.module('editingCenterModule').directive('versionTimePanel', [
    '$location', 
    'trsHttpService', 
    '$filter',
    'initVersionService',
    '$state',
    '$window',
    '$sce',
    '$q',
    function($location, trsHttpService, $filter, initVersionService, $state, $window, $sce, $q) {
        return {
            scope: {
                incomingData: '='
            },
            restrict: 'E',
            templateUrl: './editingCenter/service/versionTime/versionTimePanel/versionTimePanel_tpl.html',
            link: function(scope, iElement, iAttrs) {
                const incomingData = {
                    doctypeid: scope.incomingData.DOCTYPEID,
                    hasCopyDraft: true,
                    MetaDataId: scope.incomingData.METADATAID || scope.incomingData.DOCID,
                    chnldocid: scope.incomingData.CHNLDOCID,
                    isCrossTenant: false,
                };
                initStatus();
                initData();
        
                /**
                 * [initData description] 初始化数据
                 * @return  {[type]}  [return description]
                 */
                function initData() {
                    getOperationLog('copyOperationLog', 'operationLog', 'operationLog');
                    if (incomingData.doctypeid !== '13') {
                        getVersionTime();
                    }
                    getComment();
                    if (incomingData.hasCopyDraft === true) {
                        getCopyDraft();
                    }
                }
        
                /**
                 * [initStatus description] 初始化状态
                 * @return  {[type]}  [return description]
                 */
                function initStatus() {
                    scope.page = {
                        operationLog: {
                            CURRPAGE: 1,
                            PAGESIZE: 1000,
                            ITEMCOUNT: 1,
                            PAGECOUNT: 1,
                        },
                        copyLog: {
                            CURRPAGE: 1,
                            PAGESIZE: 1000,
                            ITEMCOUNT: 1,
                            PAGECOUNT: 1,
                        },
                        comment: {
                            CURRPAGE: 1,
                            PAGESIZE: 1000,
                            ITEMCOUNT: 1,
                            PAGECOUNT: 1,
                        },
                    };
                    scope.params = {
                        operationLog: {
                            serviceid: 'mlf_metadatalog',
                            methodname: 'query',
                            CURRPAGE: scope.page.operationLog.CURRPAGE,
                            MetaDataId: incomingData.MetaDataId,
                            PAGESIZE: scope.page.operationLog.PAGESIZE,
                        },
                        copyLog: {
                            serviceid: 'mlf_metadatalog',
                            methodname: 'query',
                            CURRPAGE: scope.page.copyLog.CURRPAGE,
                            MetaDataId: incomingData.MetaDataId,
                            PAGESIZE: scope.page.copyLog.PAGESIZE,
                        },
                        comment: {
                            serviceid: 'mlf_comment',
                            methodname: 'queryComments',
                            CURRPAGE: scope.page.comment.CURRPAGE,
                            MetaDataId: incomingData.MetaDataId,
                            PAGESIZE: scope.page.comment.PAGESIZE,
                        },
                    };
                    scope.paramsForUgc = {
                        operationLog: {
                            serviceid: 'mlf_metadatalog',
                            methodname: 'queryForUgc',
                            CURRPAGE: scope.page.operationLog.CURRPAGE,
                            UgcId: incomingData.MetaDataId,
                            PAGESIZE: scope.page.operationLog.PAGESIZE,
                        },
                        copyLog: {
                            serviceid: 'mlf_releasesource',
                            methodname: 'query',
                            CURRPAGE: scope.page.copyLog.CURRPAGE,
                            UgcId: incomingData.MetaDataId,
                            PAGESIZE: scope.page.copyLog.PAGESIZE,
                        },
                        comment: {
                            serviceid: 'mlf_comment',
                            methodname: 'queryCommentsForUgc',
                            CURRPAGE: scope.page.comment.CURRPAGE,
                            UgcId: incomingData.MetaDataId,
                            PAGESIZE: scope.page.comment.PAGESIZE,
                        },
                    };
                    scope.status = {
                        hasCopyDraft: false,
                        trench: $location.path().split('/')[2],
                        IsCurTenant: true,
                        isCrossTenant: incomingData.isCrossTenant
                    };
                    scope.data = {
                        docTypeId: incomingData.doctypeid,
                        operationLog: [],
                        copyOperationLog: [],
                        versionTime: [],
                        copyDraft: [],
                        copyDraftLog: [],
                        anthorOperationLog: [],
                        Channel: [],
                        comment: [],
                        voiceObj: {},
                        path: {
                            '-1': 'editingCenterFusionPersonalVersionTime',
                            '1': 'editingCenterAppPersonalVersionTime',
                            '2': 'editingCenterWebsitePersonalVersionTime',
                            '3': 'editingCenterPaperPersonalVersionTime',
                            '4': 'editingCenterWeixinPersonalVersionTime',
                            '5': 'wbPreview',
                            '15': 'editingCenterTelevisionPersonalVersionTime',
                            '16': 'editingCenterBroadcastPersonalVersionTime',
                            '18': 'newMediaPreview', // 跟企鹅号一样的操作
                            '19': 'newMediaPreview',
                            '20': 'newMediaPreview', // 新增的渠道就不单独写版本页面，直接使用查看页面，减少冗余代码，增加灵活性
                        },
                        versionName: {
                            '-1': 'iwoobjectversionid',
                            '1': 'appobjectversionid',
                            '2': 'wzobjectversionid',
                            '3': 'bzobjectversionid',
                            '4': 'wxobjectversionid',
                            '5': 'wbmetadataid',
                            '15': 'tvobjectversionid',
                            '16': 'bcobjectversionid',
                            '18': 'versionid', // 处理方式和企鹅号一样
                            '19': 'versionid',
                            '20': 'versionid',
                        },
                    };
                }
        
                /**
                 * [getOperationLog description]获取操作日志
                 * @param  {[type]} type [description]日志类型
                 * @param  {[type]} key  [description]日志标示
                 * @param  {[type]} page [description]日志分页信息
                 * @return {[type]}      [description]
                 */
                function getOperationLog(type, key, page) {
                    let params = incomingData.isUGC ? scope.paramsForUgc[page] : scope.params[page];
                    params.IsCurTenant = scope.status.IsCurTenant;
                    trsHttpService.httpServer(trsHttpService.getWCMRootUrl(), params, 'get').then(function (data) {
                        if (angular.isDefined(data.DATA)) {
                            // 处理复制稿切换操作日志
                            if (incomingData.isUGC) {
                                if (type === 'anthorOperationLog' && scope.paramsForUgc.copyLog.CURRPAGE == 1) {
                                    scope.data[type] = [];
                                }
                            } else {
                                if (type === 'anthorOperationLog' && scope.params.copyLog.CURRPAGE == 1) {
                                    scope.data[type] = [];
                                }
                            }
                            scope.data[type] = $filter('unique')(scope.data[type].concat(data.DATA), 'METADATALOGID');
                            scope.data.Channel[type] = $filter('groupBy')(scope.data[type], 'MEDIATYPEDESCANDPRODUCT');
                            for (var i in scope.data.Channel[type]) {
                                scope.data[key][i] = [];
                                scope.data[key][i] = initVersionService.getDayContent(scope.data.Channel[type][i], 'push').concat(scope.data[key][i]);
                            }
                            !!data.PAGER ? (scope.page[page] = data.PAGER) : (scope.page[page].ITEMCOUNT = 0);
                        }
                    });
                }
        
                /**
                 * [getVersionTime description]获得流程版本
                 * @return {[type]} [description]
                 */
                function getVersionTime() {
                    var params = {
                        serviceid: 'mlf_extversion',
                        methodname: 'queryVersions',
                        MetaDataId: incomingData.MetaDataId,
                    };
                    if (incomingData.isUGC) {
                        params.methodname = 'queryVersionsForUgc';
                        params.UgcId = incomingData.MetaDataId;
                        delete params.MetaDataId;
                    }
                    trsHttpService.httpServer(trsHttpService.getWCMRootUrl(), params, 'get').then(function (data) {
                        if (angular.isUndefined(data)) {
                            return;
                        }
                        if (scope.status.trench !== 'iWo') {
                            // 根据渠道选择不同的处理方式，除Iwo渠道按操作日志方式搞
                            scope.data.copyVersionTime = $filter('groupBy')(data, 'MEDIATYPENAME');
                            for (var i in scope.data.copyVersionTime) {
                                scope.data.versionTime[i] = [];
                                scope.data.versionTime[i] = initVersionService
                                    .getDayContent(scope.data.copyVersionTime[i], 'push')
                                    .concat(scope.data.versionTime[i]);
                            }
                        } else {
                            scope.data.versionTime = initVersionService.getDayContent(data, 'push');
                        }
                    });
                }
        
                /**
                 * [isShowVersion description] 没有操作日志或流程版本时不显示图标和'没有更多'
                 * @param  {[type]}  key [description] 操作日志或流程版本的数据
                 * @return {Boolean}     [description]
                 */
                scope.isShowVersion = function (key) {
                    if (key === undefined) {
                        return false;
                    } else {
                        for (var i in key) {
                            return true;
                        }
                        return false;
                    }
                };
        
                /**
                 * [openPersonalVersionTime description] 打开流程版本详情页
                 * @param  {[type]} item [description]
                 * @return {[type]}      [description]
                 */
                scope.openPersonalVersionTime = function (item) {
                    var path = scope.data.path[item.MEDIATYPE];
                    var params = {};
                    if (item.MEDIATYPE !== '-1') {
                        // 渠道稿件
                        var objName = scope.data.versionName[item.MEDIATYPE];
                        if (item.MEDIATYPENAME === '微博') { // 暂对微博特殊处理
                            params[objName] = item.OBJECTID;
                            params['fromversiontime'] = 'true';
                        } else {
                            params[objName] = item.OBJECTVERSIONID;
                        }
                        if (item.MEDIATYPENAME === '头条号' || item.MEDIATYPENAME === '百家号' || item.MEDIATYPENAME === '企鹅号') {
                            params['metadataid'] = item.OBJECTID;
                        }
                        var url = $state.href(path, params);
                        $window.open(url);
                    } else {
                        geRelatedversion(incomingData.MetaDataId, item.VERSIONNUM).then(function (data) {
                            params = {
                                // 融合
                                metadataid: incomingData.MetaDataId,
                                iwoobjectversionid: item.OBJECTVERSIONID,
                                wzobjectversionid: angular.isDefined(data.web) ? data.web.objversionId : '',
                                bzobjectversionid: angular.isDefined(data.paper) ? data.paper.objversionId : '',
                                appobjectversionid: angular.isDefined(data.app) ? data.app.objversionId : '',
                                wxobjectversionid: angular.isDefined(data.wechat) ? data.wechat.objversionId : '',
                                tvobjectversionid: angular.isDefined(data.television) ? data.television.objversionId : '',
                                bcobjectversionid: angular.isDefined(data.broadcast) ? data.broadcast.objversionId : '',
                                versionum: item.VERSIONNUM,
                            };
                            var url = $state.href(path, params);
                            $window.open(url);
                        });
                    }
                };
        
                /**
                 * [geRelatedversion description] 融合稿获取关联流程版本
                 * @param  {[type]} MetaDataId [description]
                 * @param  {[type]} num        [description]
                 * @return {[type]}            [description]
                 */
                function geRelatedversion(MetaDataId, num) {
                    var deffer = $q.defer();
                    var params = {
                        serviceid: 'mlf_fusionmyrelease',
                        methodname: 'getObjversionByDoc',
                        METADATAID: MetaDataId,
                        VersionNum: num,
                    };
                    trsHttpService.httpServer(trsHttpService.getWCMRootUrl(), params, 'get').then(function (data) {
                        deffer.resolve(data);
                    });
                    return deffer.promise;
                }
        
                /**
                 * [getCopyDraft description]获得复制稿以及默认显示第一个复制稿件的操作日志
                 * @return {[type]} [description]
                 */
                function getCopyDraft() {
                    var copyAndBuildParams = {
                        // 复制稿请求参数
                        serviceid: 'mlf_releasesource',
                        methodname: 'queryCopyAndBuildDocs',
                        MetaDataId: incomingData.MetaDataId,
                    };
                    if (incomingData.isUGC) {
                        copyAndBuildParams.methodname = 'queryCopyAndBuildDocsForUgc';
                        copyAndBuildParams.UgcId = incomingData.MetaDataId;
                        delete copyAndBuildParams.MetaDataId;
                    }
                    trsHttpService.httpServer(trsHttpService.getWCMRootUrl(), copyAndBuildParams, 'get').then(function (data) {
                        if (data.length !== 0) {
                            scope.status.hasCopyDraft = true;
                            scope.data.copyDraft = data;
                            if (incomingData.isUGC) {
                                scope.paramsForUgc.copyLog.MetaDataId = scope.data.copyDraft[0].METADATAID;
                                scope.paramsForUgc.copyLog.CURRPAGE = 1;
                            } else {
                                scope.paramsForUgc.copyLog.MetaDataId = scope.data.copyDraft[0].METADATAID;
                                scope.paramsForUgc.copyLog.CURRPAGE = 1;
                            }
                            getOperationLog('anthorOperationLog', 'copyDraftLog', 'copyLog');
                        }
                    });
                }

                /**
                 * [getCopyDraftLog description]点击切换复制稿日志
                 * @param  {[type]} metadataid [description]稿件ID
                 * @return {[type]}            [description]
                 */
                scope.getCopyDraftLog = function (metadataid) {
                    if (incomingData.isUGC) {
                        scope.paramsForUgc.copyLog.MetaDataId = metadataid;
                        scope.paramsForUgc.copyLog.CURRPAGE = 1;
                    } else {
                        scope.params.copyLog.MetaDataId = metadataid;
                        scope.params.copyLog.CURRPAGE = 1;
                    }
                    getOperationLog('anthorOperationLog', 'copyDraftLog', 'copyLog');
                };
        
                /**
                 * [getLoadMore description]点击加载更多
                 * @param  {[type]} type [description]日志种类
                 * @param  {[type]} key  [description]日志标示
                 * @param  {[type]} page [description]日志分页信息
                 * @return {[type]}      [description]
                 */
                scope.getLoadMore = function (type, key, page) {
                    if (incomingData.isUGC) {
                        scope.paramsForUgc[page].CURRPAGE += 1;
                    } else {
                        scope.params[page].CURRPAGE += 1;
                    }
                    getOperationLog(type, key, page);
                };
                scope.getLoadMoreComment = function () {
                    if (incomingData.isUGC) {
                        scope.paramsForUgc.comment.CURRPAGE += 1;
                    } else {
                        scope.params.comment.CURRPAGE += 1;
                    }
                    getComment();
                };
        
                /**
                 * [getComment description] 评审意见
                 * @return  {[type]}  [return description]
                 */
                function getComment() {
                    let params = incomingData.isUGC ? scope.paramsForUgc.comment : scope.params.comment;
                    trsHttpService.httpServer(trsHttpService.getWCMRootUrl(), params, 'post').then(function (data) {
                        if (angular.isDefined(data.DATA)) {
                            angular.forEach(data.DATA, function (value, key) {
                                if (value.COMMTYPE == '2') {
                                    requestVoice(value.COMMENT);
                                }
                            });
                            // scope.data.comment = initVersionService.getDayContent(data.DATA).concat(scope.data.comment);
                            data.DATA.reverse();
                            var moreComment = initVersionService.getDayContent(data.DATA);
                            if (
                                angular.isDefined(scope.data.comment[scope.data.comment.length - 1]) &&
                                $filter('date')(scope.data.comment[scope.data.comment.length - 1].day, 'yyyy-MM-dd').toString() ==
                                $filter('date')(moreComment[0].day, 'yyyy-MM-dd').toString()
                            ) {
                                scope.data.comment[scope.data.comment.length - 1].times = scope.data.comment[scope.data.comment.length - 1].times.concat(
                                    moreComment[0].times
                                );
                                moreComment.shift();
                            }
                            scope.data.comment = scope.data.comment.concat(moreComment);
                            !!data.PAGER ? (scope.page.comment = data.PAGER) : (scope.page.comment.ITEMCOUNT = 0);
                        }
                    });
                }
        
                /**
                 * [trustUrl description]信任url
                 */
                scope.trustUrl = $sce.trustAsResourceUrl;
        
                /**
                 * [opinionToggle description] 意见展示与否
                 * @param  {[object]} item [description] 时间线
                 * @return {[type]}      [description]
                 */
                scope.opinionToggle = function (item) {
                    if (angular.isUndefined(item.isShowOpinion) || item.isShowOpinion == false) {
                        item.isShowOpinion = true;
                    } else {
                        item.isShowOpinion = false;
                    }
                };
        
                scope.callback = function() {
                    scope.status.IsCurTenant = !scope.status.IsCurTenant;
                    scope.data['copyOperationLog'] = [];
                    getOperationLog('copyOperationLog', 'operationLog', 'operationLog');
                };
            },
        };
    }
]);
